import WrappedAuthContainer, { WrappedComponent } from './WrappedAuthContainer';
import AuthContainerModal from './AuthContainerModal';

export default WrappedAuthContainer;

export {
  WrappedComponent,
  AuthContainerModal,
};
